import React from 'react'
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import Col from 'react-bootstrap/Col';
import Form from 'react-bootstrap/Form';
import Row from 'react-bootstrap/Row';
import { faGrinTongueSquint } from '@fortawesome/free-solid-svg-icons';

class AddItemModal extends React.Component {
    constructor(props){
        super(props);
        this.state = {
            show: false,
            name: "",
            purchase_price:"1",
            sale_price:"1",
            qty:"1",
            barcode:"",
        };
        this.handleSubmitItem = this.handleSubmitItem.bind(this);
    }
    handleChange = (e) => {
        this.setState({[e.target.id]: e.target.value});
        
    };
    handleSubmitItem(e){
        console.log(e);
        if(this.state.name !== "" && this.state.barcode !== "" && this.state.qty !== "" && this.state.purchase_price !== ""
        && this.state.sale_price !== ""){
            this.props.addItemsOnClick(this.state);
            this.props.handleClose();
        }
    }
    componentDidUpdate(prevProps, prevState) {
        if(prevProps !== this.props){
            this.setState({
                name: this.props.state.name,
                barcode: this.props.state.barcode,
                qty: this.props.state.qty,
                sale_price: this.props.state.sale_price,
                purchase_price: this.props.state.purchase_price,
            })
        }
    }

        
    render(){
        return(

        <React.Fragment>

            <Modal show={this.props.show} onHide={this.props.handleClose}>
                <Modal.Header closeButton>
                    <Modal.Title>New Item</Modal.Title>
                </Modal.Header>
                <Modal.Body>Woohoo, increase your inventory
                    <Form.Group as={Row} className="mb-3">
                        <Col sm={10}>
                        <Form.Label>Product Name: </Form.Label>
                        <Form.Control id="name" type="text" onChange={this.handleChange} value={this.state.name} placeholder="Product Description"/>    
                        </Col>
                        <Col sm={2}>
                            <Form.Label>Qty</Form.Label>
                            <Form.Control id="qty" type="number" onChange={this.handleChange} value={this.state.qty}  />
                        </Col>       
                    </Form.Group>
                    <Form.Group as={Row}>
                        <Col sm={6}>
                        <Form.Label>Purchase Price: </Form.Label>
                        <Form.Control id="purchase_price" type="number" onChange={this.handleChange} value={this.state.purchase_price} />          
                        </Col>
                        <Col sm={6}>
                        <Form.Label>Sale Price: </Form.Label>
                        <Form.Control id="sale_price" type="number" onChange={this.handleChange} value={this.state.sale_price} />   
                        </Col>       
                    </Form.Group>
                    <Form.Group>
                        <Form.Label>Barcode</Form.Label>
                        <Form.Control id="barcode"  type="text" onChange={this.handleChange} value={this.state.barcode}/>
                    </Form.Group>

                </Modal.Body>
                <Modal.Footer>
                    
                    {/* <Button variant="primary" onClick={this.props.addItemsOnClick}>
                        Add Item
                    </Button> */}
                    <Button variant="primary" onClick={this.handleSubmitItem}>
                        Submit
                    </Button>

                    <Button variant="secondary" onClick={this.props.handleClose}>
                        Close
                    </Button>
                </Modal.Footer>
            </Modal>

            </React.Fragment>

)}
}
export default AddItemModal